import { render, staticRenderFns } from "./ReportProduct.vue?vue&type=template&id=6b54257e&"
import script from "./ReportProduct.vue?vue&type=script&lang=js&"
export * from "./ReportProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports